import { useAuthStore } from "store/authStore";

export const authFetch = async (
    input: RequestInfo,
    init: RequestInit = {},
) => {
    const accessToken = useAuthStore.getState().accessToken;
    if (!accessToken) throw new Error('No access token found');

    const headers = {
        ...(init.headers || {}),
        'Authorization': `JWT ${accessToken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };

    return fetch(input, {
        ...init,
        headers,
        credentials: 'include',
    });
};